// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FaOj","colMin":"styles_colMin__1UndM"};